var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "promotion_config_pane" },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, "label-width": "100px" } },
        [
          _c("div", { staticClass: "form_body" }, [
            _c(
              "div",
              { staticClass: "left_pane" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "活动名称：", prop: "activityName" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入活动名称" },
                      model: {
                        value: _vm.form.activityName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "activityName", $$v)
                        },
                        expression: "form.activityName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", { attrs: { label: "优惠周期：" } }, [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                        },
                        model: {
                          value: _vm.form.executeDateList,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "executeDateList", $$v)
                          },
                          expression: "form.executeDateList",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "资格限制", prop: "vipMember" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        attrs: { size: "small" },
                        model: {
                          value: _vm.form.vipMember,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "vipMember", $$v)
                          },
                          expression: "form.vipMember",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: false } }, [
                          _vm._v("\n                游客\n              "),
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: true } }, [
                          _vm._v("\n                会员\n              "),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.form.vipMember
                      ? _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.form.memberLevels,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "memberLevels", $$v)
                              },
                              expression: "form.memberLevels",
                            },
                          },
                          _vm._l(_vm.memberLevelList, function (item) {
                            return _c(
                              "el-checkbox",
                              {
                                key: item.gradeId,
                                attrs: { label: item.gradeId },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.gradeName) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "应用场景" } },
                  [
                    _c(
                      "el-card",
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "订餐类型", prop: "orderType" } },
                          [
                            _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.form.menuTypes,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "menuTypes", $$v)
                                  },
                                  expression: "form.menuTypes",
                                },
                              },
                              _vm._l(_vm.menuTypeList, function (item) {
                                return _c(
                                  "el-checkbox",
                                  {
                                    key: item.code,
                                    attrs: { label: item.code },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.desc) +
                                        "\n                  "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "使用范围" } },
                  [
                    _c("el-checkbox", {
                      attrs: { label: "是否关联全部商品" },
                      model: {
                        value: _vm.form.markAllGoods,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "markAllGoods", $$v)
                        },
                        expression: "form.markAllGoods",
                      },
                    }),
                    _vm._v(" "),
                    !_vm.form.markAllGoods
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { size: "small" },
                                model: {
                                  value: _vm.form.targetScope,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "targetScope", $$v)
                                  },
                                  expression: "form.targetScope",
                                },
                              },
                              [
                                _c(
                                  "el-radio",
                                  { attrs: { label: "category" } },
                                  [
                                    _vm._v(
                                      "\n                  分类\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: "goods" } }, [
                                  _vm._v(
                                    "\n                  商品\n                "
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.form.targetScope === "category"
                              ? _c(
                                  "div",
                                  [
                                    _c("el-cascader-panel", {
                                      attrs: {
                                        options: _vm.goodsCategoryTree,
                                        clearable: "",
                                        "collapse-tags": "",
                                        props: _vm.categoryCascadeProps,
                                      },
                                      model: {
                                        value: _vm.form.checkedCategoryIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "checkedCategoryIds",
                                            $$v
                                          )
                                        },
                                        expression: "form.checkedCategoryIds",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.form.targetScope === "goods"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "70%" },
                                        attrs: {
                                          filterable: "",
                                          remote: "",
                                          "reserve-keyword": "",
                                          placeholder: "请搜索选项关联商品",
                                          "remote-method": _vm.searchGoods,
                                          loading: _vm.searchGoodsLoading,
                                          "value-key": "goodsFnId",
                                        },
                                        model: {
                                          value: _vm.checkedGoods,
                                          callback: function ($$v) {
                                            _vm.checkedGoods = $$v
                                          },
                                          expression: "checkedGoods",
                                        },
                                      },
                                      _vm._l(_vm.goodsList, function (item) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: item.goodsFnId,
                                            attrs: {
                                              label: item.goodsName,
                                              value: item,
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-items": "center",
                                                  "justify-content":
                                                    "space-between",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(item.goodsName)
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(item.goodsCode)
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        )
                                      }),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: { click: _vm.addGoods },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  添加\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-table",
                                      {
                                        key: _vm.goodsTableKey,
                                        staticStyle: { width: "70%" },
                                        attrs: {
                                          border: "",
                                          data: _vm.form.checkedGoodsList,
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "goodsCode",
                                            label: "商品编号",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "goodsName",
                                            label: "商品名称",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: { label: "操作" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          type: "text",
                                                          size: "small",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeGoods(
                                                              scope.row
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        移除\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            12510260
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "阶梯规则" } },
                  [
                    _c(
                      "el-card",
                      [
                        _c(
                          "template",
                          { slot: "header" },
                          [
                            _c(
                              "el-form",
                              { attrs: { inline: true } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "订单门槛" } },
                                  [
                                    _c("el-input-number", {
                                      attrs: { min: 1 },
                                      model: {
                                        value: _vm.threshold,
                                        callback: function ($$v) {
                                          _vm.threshold = $$v
                                        },
                                        expression: "threshold",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "优惠金额" } },
                                  [
                                    _c("el-input-number", {
                                      attrs: { min: 1 },
                                      model: {
                                        value: _vm.discount,
                                        callback: function ($$v) {
                                          _vm.discount = $$v
                                        },
                                        expression: "discount",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.addTiersRule },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      添加\n                    "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { data: _vm.form.tiersRuleList },
                          },
                          [
                            _c("el-table-column", {
                              attrs: { prop: "threshold", label: "订单门槛" },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { prop: "discount", label: "优惠金额" },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "操作" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeTiersRule(
                                                scope.$index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      移除\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { key: _vm.refreshKey, staticClass: "right_pane" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "全部门店：", prop: "storeScope" } },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { "true-label": 0, "false-label": 1 },
                        model: {
                          value: _vm.form.storeScope,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "storeScope", $$v)
                          },
                          expression: "form.storeScope",
                        },
                      },
                      [_vm._v("\n              全部门店\n            ")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.form.storeScope === 1
                  ? _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "指定门店",
                          prop: "relatedStoreIdList",
                        },
                      },
                      _vm._l(_vm.regionStoreList, function (regionStore) {
                        return _c("region-store-pane", {
                          key: regionStore.regionId,
                          ref: "regionStore_" + regionStore.regionId,
                          refInFor: true,
                          attrs: {
                            "region-store": regionStore,
                            "echo-store-ids": _vm.form.relatedStoreIdList,
                          },
                          on: { change: _vm.handleRegionStoreChange },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("\n          提交\n        ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }